module.exports = __webpack_public_path__ + "assets/93ffb14f2257f129c85f525403cfe93c.png";